import {
  studyAnswerResponseSchema,
  studyAnswerSchema,
  studyNextSchema,
  type StudyAnswer,
  type StudyAnswerResponse,
  type StudyCard,
  type StudyFeedback,
  type StudyNextResponse,
} from '../../shared/contracts/study-api.ts';
import type { DeckScope } from '../../shared/deck.ts';
import { parseJsonResponse } from './api-client.ts';

export type {
  StudyAnswer,
  StudyAnswerResponse,
  StudyCard,
  StudyFeedback,
  StudyNextResponse,
} from '../../shared/contracts/study-api.ts';

export async function getNextStudyCard(
  deckId: string,
  recentlyShownCardId?: string,
  fetcher: typeof fetch = fetch,
  scope?: DeckScope,
  signal?: AbortSignal,
): Promise<StudyNextResponse> {
  const params = new URLSearchParams();
  if (recentlyShownCardId)
    params.set('recentlyShownCardId', recentlyShownCardId);
  if (scope?.sectionSlug) params.set('section', scope.sectionSlug);
  if (scope?.unitSlug) params.set('unit', scope.unitSlug);
  if (scope?.topicSlug) params.set('topic', scope.topicSlug);
  const query = params.size ? `?${params.toString()}` : '';
  const url = `/api/decks/${deckId}/study/next${query}`;
  const response =
    signal === undefined ? await fetcher(url) : await fetcher(url, { signal });
  return parseJsonResponse(response, studyNextSchema, 'Study request failed');
}

export async function submitStudyAnswer(
  deckId: string,
  cardId: string,
  answer: StudyAnswer,
  fetcher: typeof fetch = fetch,
  scope?: DeckScope,
): Promise<StudyAnswerResponse> {
  const body = studyAnswerSchema.parse({ answer, cardId, scope });
  return parseJsonResponse(
    await fetcher(`/api/decks/${deckId}/study/answer`, {
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    }),
    studyAnswerResponseSchema,
    'Study request failed',
  );
}

export async function submitStudyAnswerAndNotify(
  deckId: string,
  cardId: string,
  answer: StudyAnswer,
  onReviewRecorded: (() => void | Promise<void>) | undefined,
  submitter: typeof submitStudyAnswer = submitStudyAnswer,
): Promise<StudyAnswerResponse> {
  const response = await submitter(deckId, cardId, answer);
  void onReviewRecorded?.();
  return response;
}
